import { updateProfile } from "firebase/auth";
import React, { useRef, useState } from "react";
import { Alert, Button, Card, Container, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function SignUp() {
  const userNameRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const { signUp } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigation = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    if (passwordRef.current.value.length < 6) {
      return setError("Passwort muss mindestens 6 Zeichen lang sein.");
    }

    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwörter stimmen nicht überein.");
    }

    try {
      setError("");
      setLoading(true);
      const userCredentials = await signUp(
        emailRef.current.value,
        passwordRef.current.value
      );
      updateProfile(userCredentials.user, {
        displayName: userNameRef.current.value,
      });
      setLoading(false);
      navigation("/hints");
    } catch (e) {
      console.log(e.message);
      setError("Fehler bei der Registrierung!");
      setLoading(false);
    }
  }

  return (
    <Container
      className="align-items-center justify-content-center"
      style={{
        maxWidth: "700px",
        minWidth: "300px",
        padding: "100px 50px",
      }}
    >
      <Card>
        <Card.Body>
          <h2 className="text-center mb-3">Registrieren</h2>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit} autoComplete="off">
            <Form.Group id="userName" className="w-100 mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control type="name" ref={userNameRef} required />
            </Form.Group>
            <Form.Group id="email" className="w-100 mb-3">
              <Form.Label>E-Mail</Form.Label>
              <Form.Control type="email" ref={emailRef} required />
            </Form.Group>
            <Form.Group id="password" className="w-100 mb-3">
              <Form.Label>Passwort</Form.Label>
              <Form.Control type="password" ref={passwordRef} required />
              <Form.Text id="passwordHelpBlock" muted>
                Das Password muss mindestens 6 Zeichen lang sein.
              </Form.Text>
            </Form.Group>

            <Form.Group id="password-confirmation" className="w-100 mb-4">
              <Form.Label>Passwort bestätigen</Form.Label>
              <Form.Control type="password" ref={passwordConfirmRef} required />
            </Form.Group>
            <Button disabled={loading} className="w-100" type="submit">
              Konto erstellen
            </Button>
          </Form>
        </Card.Body>
      </Card>
      <div className="text-center mt-2">
        Du hast bereits ein Konto? <Link to="/login">Anmelden</Link>
      </div>
    </Container>
  );
}
